formFieldsDirective = angular.module('formfields.setting', [])

formFieldsDirective.filter 'toArray',["$timeout", ($timeout) ->
  (obj) ->
    result = []
    _.each obj, (val, hash) ->
      result.push {name: val, value: hash}
    result
]

formFieldsDirective.directive "formFieldsSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "ContentEditable", "Widget", "blockEditDialog", "$rootScope", "$filter", ($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, $rootScope, $filter) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  templateUrl: "#{settingFolder}/formfields/template.jade"
  link: (scope, element, attrs, ngModel) ->
    id = attrs.widgetId
    widgetElWrapper = angular.element("[data-block-id=#{id}]").find ns.widgetWrapperClass

    setSelectedFirstGroup = ->
      for category in scope.data.categories
        for group, index in category.groups
          if index is 0
            group.selected = true
            return false

    setSelectedOldGroups = (type) ->
      oldCategories = angular.copy scope.data[type]
      scope.data[type] = angular.copy window.justclick.formCategories
      for oldcategory in scope.data[type]
        for group in oldcategory.groups
          for oc in oldCategories
            for ocgroup in oc.groups
              if group.name is ocgroup.name and ocgroup.selected
                group.selected = true


    offertField = _.filter(scope.data.form_fields_attributes, {offert: true})[0]
    index = scope.data.form_fields_attributes.indexOf(offertField)
    if index > -1
      scope.data.form_fields_attributes[index].value = $filter('translate')('widget.form.offertText1')
      scope.data.form_fields_attributes[index].title = $filter('translate')('widget.form.offertText1')


    if scope.data.categories and scope.data.categories.length is 0
      scope.data.categories = angular.copy window.justclick.formCategories
      setSelectedFirstGroup()
    else
      setSelectedOldGroups "categories"

    if scope.data.ex_categories.length is 0
      scope.data.ex_categories = angular.copy window.justclick.formCategories
    else
      setSelectedOldGroups "ex_categories"

    scope.form = angular.copy scope.data

    getNotDestroyedFieldRnd = ->
      fields = []
      _.each scope.form.form_fields_attributes, (field, index) ->
        if !field._destroy
          fields.push index
      if fields.length > 0
        fields[fields.length-1]
      else
        0

    scope.currentField = getNotDestroyedFieldRnd()

    scope.setCurrentField = (index) ->
      scope.currentField = index

    # drag and sort

    scope.treeOptions =
      dropped: (e) ->
        fieldsIds = []
        _.each scope.form.form_fields_attributes, (field) ->
          if field.id
            fieldsIds.push field.id
        Widget.sortFormFields attrs.widgetId, fieldsIds


    # input types with name

    scope.inputTypes = [
      {field_type: "text", name: "Text", title: $filter('translate')('widget.form.fieldType1')}
      {field_type: "number", name: "Number", title: $filter('translate')('widget.form.fieldType2')}
      {field_type: "tel", name: "Phone", title: $filter('translate')('widget.form.fieldType3')}
      {field_type: "email", name: "Email", title: $filter('translate')('widget.form.fieldType4')}
      {field_type: "url", name: "Url", title: $filter('translate')('widget.form.fieldType5')}
      {field_type: "textarea", name: "Text Area", title: $filter('translate')('widget.form.fieldType6')}
      {field_type: "select", name: "Select", title: $filter('translate')('widget.form.fieldType7')}
      {field_type: "checkbox", name:"Checkbox", title: $filter('translate')('widget.form.fieldType8')}
      {field_type: "radio", name:"Radio", title: $filter('translate')('widget.form.fieldType9')}
    ]

    fieldExist = (field_) ->
      for field in scope.form.form_fields_attributes
        if field_.name is field.name
          return true
      return false


    removeDeletedAdditionalFields = ->
      defaultFields = [
        "lead_name",
        "lead_email",
        "lead_phone",
        "lead_middle_name",
        "lead_last_name",
        "lead_city",
        "lead_offert"
      ]

      formclone = angular.copy scope.form
      needUpdate = 0

      for field in formclone.form_fields_attributes
        notDefaultFields = field.name not in defaultFields
        if notDefaultFields
          needForDestroy = (_.filter(window.justclick.additionalFields, {name: field.name, title: field.title})).length is 0
          if needForDestroy
            needUpdate++
            field._destroy = true

      if needUpdate > 0
        sectionId = blockEditDialog.getSectionId id:formclone.id
        Widget.update(sectionId, formclone).then (data) ->
          scope.form.form_fields_attributes = data.form_fields_attributes
      else
        {then: (cb) -> cb()}

    addAdditionalFields = ->
      removeDeletedAdditionalFields().then ->
        if window.justclick.additionalFields
          fieldsForAddingCount = 0
          _.each window.justclick.additionalFields, (field) ->
            if !fieldExist(field)
              fieldsForAddingCount++
              scope.form.form_fields_attributes.push field
          if fieldsForAddingCount > 0
            sectionId = blockEditDialog.getSectionId id:scope.form.id
            Widget.update(sectionId, scope.form).then (data) ->
              scope.form.form_fields_attributes = data.form_fields_attributes

    addAdditionalFields()


    scope.add = ->
      scope.form.form_fields_attributes.push {field_type:"text"}
      length = scope.form.form_fields_attributes.length
      scope.currentField = length - 1
      scope.setTitleAsType "text"

    scope.fieldsLength = (fields) ->
      destroyed = _.filter fields, _destroy: true
      fields.length - destroyed.length

    scope.remove = ->
      scope.form.form_fields_attributes[scope.currentField]._destroy = true
      scope.currentField = getNotDestroyedFieldRnd()

    fieldChanged = (newVal, oldVal, fieldType) ->
      for field, index in newVal
        if oldVal[index] and field[fieldType] isnt oldVal[index][fieldType]
          return true
      return false

    trimNbsp = (fields) ->
      for field in fields
        field.title = field.title.replace(/&nbsp;/gi,'')
      fields

    listeners = []

    changeFormType = (newType, oldType) ->
      if newType is "subscription"
        formInputsHtmlRender scope.form.form_fields_attributes
        setFormStyles scope.data.form_style

    listeners.push scope.$watch "data.form_type", changeFormType

    listeners.push scope.$watch "form", (newVal) ->
      return false if !ngModel
      ngModel.$setViewValue newVal

    listeners.push scope.$watch "data.button", (newVal) ->
      setButtonStyles newVal
    , true

    listeners.push scope.$watch "data.parent_button", (newVal) ->
      setParentButtonStyles newVal
    , true

    listeners.push scope.$watch "data.form_style", (newVal) ->
      setFormStyles newVal
    , true

    listeners.push scope.$watch "data.form_fields_style_attributes", (newVal) ->
      setFormFieldsStyles newVal
    , true

    listeners.push scope.$watch "data.labels_style_attributes", (newVal) ->
      setLabelsStyles newVal
    , true

    listeners.push scope.$watch "data.as_modal", (newVal) ->
      modalTransform newVal

    listeners.push scope.$watch "data.form_design", (newVal, oldVal) ->
      # if newVal is oldVal then return false
      scope.form.form_design = newVal
      # addNameEnField scope.form.form_fields_attributes
      formInputsHtmlRender scope.form.form_fields_attributes

    listeners.push scope.$watch "data.labels", (newVal, oldVal) ->
      # if newVal is oldVal then return false
      scope.form.labels = newVal
      # addNameEnField scope.form.form_fields_attributes
      formInputsHtmlRender scope.form.form_fields_attributes

    listeners.push scope.$watch "form.form_fields_attributes", (newVal, oldVal) ->
      scope.data.form_fields_attributes = trimNbsp newVal
      needForChange = fieldChanged(newVal, oldVal, "placeholder") or fieldChanged(newVal, oldVal, "options_raw") or fieldChanged(newVal, oldVal, "exist") or fieldChanged(newVal, oldVal, "hidden")
      if scope.fieldsLength(newVal) isnt scope.fieldsLength(oldVal) or needForChange
        # addNameEnField newVal
        formInputsHtmlRender newVal
    , true

    scope.$on "$destroy", ->
      _.each listeners, (listener) ->
        listener()


    scope.setTitleAsType = (type) ->
      finded = _.filter scope.inputTypes, {field_type: type}
      scope.form.form_fields_attributes[scope.currentField].title = finded[0].title
      scope.form.form_fields_attributes[scope.currentField].placeholder = finded[0].title

    # name helpers

    emptyName = (variable) ->
      variable || "No name"

    emptyDesc = (variable) ->
      variable || ""


    # generate fields

    generateUrlInput = (field) ->
      translit = translitService.cyrillToLatin emptyName(field.placeholder)
      required = if field.required then "required=''" else ""
      "<input readonly='' #{required} type='url' name='#{translit}' class='strwf__input' placeholder='#{emptyName(field.placeholder)}'>"

    generateEmailInput = (field) ->
      translit = translitService.cyrillToLatin emptyName(field.placeholder)
      required = if field.required then "required=''" else ""
      "<input readonly='' #{required} type='email' name='#{translit}' class='strwf__input' placeholder='#{emptyName(field.placeholder)}'>"

    generateTextInput = (field) ->
      translit = translitService.cyrillToLatin emptyName(field.placeholder)
      required = if field.required then "required=''" else ""
      "<input readonly='' #{required} type='text' name='#{translit}' class='strwf__input' placeholder='#{emptyName(field.placeholder)}'>"


    generateNumberInput = (field) ->
      translit = translitService.cyrillToLatin emptyName(field.placeholder)
      required = if field.required then "required=''" else ""
      "<input readonly='' #{required} type='number' name='#{translit}' class='strwf__input' placeholder='#{emptyName(field.placeholder)}'>"

    generatePhoneInput = (field) ->
      translit = translitService.cyrillToLatin emptyName(field.placeholder)
      required = if field.required then "required=''" else ""
      "<input readonly='' #{required} type='tel' name='#{translit}' class='strwf__input' placeholder='#{emptyName(field.placeholder)}'>"

    generateTextareaInput = (field) ->
      translit = translitService.cyrillToLatin emptyName(field.placeholder)
      required = if field.required then "required=''" else ""
      "<textarea readonly='' #{required} class='strwf__input strwf__input_textarea' name='#{translit}' placeholder='#{emptyName(field.placeholder)}'></textarea>"

    generateSelectInput = (field) ->
      translit = translitService.cyrillToLatin emptyName(field.placeholder)
      required = if field.required then "required=''" else ""
      if field.options_raw
        options = field.options_raw.split("\n")
        optionsHtml = ""
        _.each options, (option) ->

          if option is field.value
            selected = "selected=''"
          else
            selected = ""

          optionsHtml += "<option value='#{option}' #{selected}>#{option}</option>"
      "<select #{required} class='strwf__input' name='#{translit}'>#{optionsHtml}</select>"

    generateCheckboxInput = (field, index) ->
      translit = translitService.cyrillToLatin emptyName(field.placeholder)
      if field.title is field.value
        selected = "checked=''"
      else
        selected = ""
      optionsHtml = "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='#{field.title}' id='strwf-1-#{field.id}' type='checkbox' name='entity[{{field.name}}]' #{selected}><label contenteditable='false' data-access='form_fields_attributes.#{index}.title' class='strwf__radio-label' for='strwf-1-#{field.id}'>#{field.title}</label></div>"
      if field.offert
        optionsHtml = "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='#{field.title}' id='strwf-1-#{field.id}' type='checkbox' checked='true' name='entity[{{field.name}}]' #{selected}><label class='strwf__radio-label' for='strwf-1-#{field.id}'>#{$filter('translate')('widget.form.offertText')}</label></div>"
      optionsHtml

    generateRadioInput = (field) ->
      translit = translitService.cyrillToLatin emptyName(field.placeholder)
      options = field.options_raw.split("\n")
      optionsHtml = ""
      _.each options, (option, index) ->
        if option is field.value
          selected = "checked=''"
        else
          selected = ""
        optionsHtml += "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='#{option}' id='strwfr-#{field.name}-#{index}-1' type='radio' name='entity[#{field.name}]' #{selected}><label class='strwf__radio-label' for='strwfr-#{field.name}-#{index}-1'>#{option}</label></div>"
      optionsHtml

    setButtonStyles = (newVal) ->
      scope.form.button = newVal
      widgetElWrapper.find(ns.widgetFormButtonWrapperClass).css "text-align", newVal.style["textAlign"]
      if newVal.style.textAlign
        style = angular.copy newVal.style
        delete style.textAlign
      widgetElWrapper.find(".strwf_form-button").css style

    setParentButtonStyles = (newVal) ->
      scope.form.parent_button = newVal
      widgetElWrapper.find(ns.widgetFormParentButtonWrapperClass).css "text-align", newVal.style["textAlign"]
      if newVal.style.textAlign
        style = angular.copy newVal.style
        delete style.textAlign
      widgetElWrapper.find(".strwf__parent-button").css style

    setFormFieldsStyles = (newVal) ->
      scope.form.form_fields_style_attributes = newVal
      widgetElWrapper.find(".strwf__input").css newVal

    setLabelsStyles = (newVal) ->
      scope.form.labels_style_attributes = newVal
      widgetElWrapper.find(".strwf__label").css newVal

    setFormStyles = (newVal) ->
      widgetElWrapper.find("form").css newVal

    modalTransform = (newVal) ->
      form = widgetElWrapper.find ".strwf__form"
      button = "<div class='#{ns.widgetFormParentButtonWrapperClass.substr(1)}'><label type='submit' contenteditable='false' data-access='parent_button.value' class='strwf_button strwf__parent-button'>#{scope.form.parent_button.value}</label></div>"
      widgetElWrapper.find("#{ns.widgetFormParentButtonWrapperClass}").remove()
      if newVal
        form.hide()
        widgetElWrapper.prepend button
        setParentButtonStyles scope.form.parent_button
        ContentEditable.bind false, true, id
      else
        widgetElWrapper.find(".subscribe-form__modal-title").remove()
        form.show()

    getExistFieldsLength = (fields) ->
      (_.filter fields, {exist: false}).length


    # generate form with fields

    formInputsHtmlRender = (fields) ->
      return false if scope.data.form_type is "order"
      output = ""
      fieldsWithLabelBlock = ["checkbox", "radio"]
      fieldsWithOptions = ["checkbox", "radio", "select"]
      inlineClasses = ""
      buttonLabel = ""


      _.each fields, (field, index) ->

        if !field.options_created and field.field_type in fieldsWithOptions and !field.options_raw
          field.options_raw = "Вариант 1\nВариант 2\nВариант 3"
          field.options_created = true

        # If field not destroyed

        if !field._destroy and field.exist and !field.hidden

          if scope.form.form_design is "horizontal"
            existFieldsLength = getExistFieldsLength(fields)
            inlineClasses = "strwf__input-inline strwf__input-wrapper_#{scope.fieldsLength(fields)+1-existFieldsLength}"

          displayBlock = if field.field_type in fieldsWithLabelBlock then "strwf__label_block" else ""

          output += "<div class='strwf__input-wrapper #{inlineClasses}'>"

          if scope.form.labels && !field.offert
            output += "<label class='strwf__label #{displayBlock}' contenteditable='false' data-access='form_fields_attributes.#{index}.title'>#{emptyDesc(field.title)}</label>"
            buttonLabel = if scope.form.form_design == 'horizontal' then "<div class='strwf__label'>​</div>" else ""

          switch field.field_type
            when "text"
              output += generateTextInput(field)
            when "number"
              output += generateNumberInput(field)
            when "textarea"
              output += generateTextareaInput(field)
            when "select"
              output += generateSelectInput(field)
            when "checkbox"
              output += generateCheckboxInput(field, index)
            when "radio"
              output += generateRadioInput(field)
            when "tel"
              output += generatePhoneInput(field)
            when "email"
              output += generateEmailInput(field)
            when "url"
              output += generateUrlInput(field)
          output += "<span id='"+field.nameEn+"' class='error-text'></span></div>"

      button = "<div class='strwf__button-wrapper strwf__form-button__wrapper #{inlineClasses}'>#{buttonLabel}<label type='submit' class='strwf_button strwf_form-button' contenteditable='false' data-access='button.value'>#{scope.form.button.value}</label></div>"

      widgetElWrapper.find("form").html ''
      widgetElWrapper.find("form").append output
      widgetElWrapper.find("form").append button
      setButtonStyles scope.data.button
      setFormFieldsStyles scope.data.form_fields_style_attributes
      setLabelsStyles(scope.data.labels_style_attributes)
      ContentEditable.bind false, true, id

]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/formfields/formfields.directive.coffee